import { render, staticRenderFns } from "./lk-file.vue?vue&type=template&id=0a7c0e95&"
import script from "./lk-file.vue?vue&type=script&lang=js&"
export * from "./lk-file.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/lk-file/lk-file.vue
// module id = 1394
// module chunks = 0